import {inject, customElement, containerless, bindable} from "aurelia-framework";
import {ContentService} from "../../../../services/content-service";

@containerless()
@inject(ContentService)
@customElement("widgets-view-header")
export class WidgetsHeader {

  @bindable widgetStore = false;

  constructor(public contentService: ContentService) {
    this.contentService = contentService;
  }

  showWidgetStore() {
    this.contentService.showWidgetStore();
  }

  showUserApps() {
    this.contentService.showTiedWidgets();
  }

}
